<template>
  <div class="category-manage">
    <div class="search-bar">
      <el-input
        v-model="searchKeyword"
        placeholder="请输入分类名称搜索"
        style="width: 200px; margin-right: 10px;"
        @keyup.enter="searchCategories"
      ></el-input>
      <el-select
        v-model="selectedStatus"
        placeholder="请选择状态"
        style="width: 150px; margin-right: 10px;"
        clearable
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="上架中" :value="1"></el-option>
        <el-option label="下架中" :value="0"></el-option>
      </el-select>
      <el-button type="primary" @click="searchCategories">搜索</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </div>
    
    <div class="add-section">
      <el-button type="primary" @click="addCategory">新增分类</el-button>
    </div>

    <el-table :data="categoryList" style="width: 100%" v-loading="loading">
      <el-table-column prop="name" label="课程分类" width="180"></el-table-column>
      <el-table-column prop="sort" label="排序" width="100" align="center"></el-table-column>
      <el-table-column prop="courseCount" label="课程数量" width="160" align="center">
        <template slot-scope="scope">
          <el-tag type="info">{{ scope.row.courseCount || 0 }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="120" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '上架中' : '下架中' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createAt" label="创建时间" width="180">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.createAt) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="240" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="editCategory(scope.row)">编辑</el-button>
          <el-button 
            size="mini" 
            :type="scope.row.status === 1 ? 'warning' : 'success'"
            @click="toggleStatus(scope.row)"
          >
            {{ scope.row.status === 1 ? '下架' : '上架' }}
          </el-button>
          <el-button 
            size="mini" 
            type="danger" 
            @click="deleteCategory(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 20px; text-align: right;"
    ></el-pagination>

    <!-- 添加/编辑分类对话框 -->
    <el-dialog
      :title="isEdit ? '编辑分类' : '添加分类'"
      :visible.sync="showAddDialog"
      width="500px"
      @close="resetForm"
    >
      <el-form :model="categoryForm" :rules="rules" ref="categoryForm" label-width="100px">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="categoryForm.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="分类描述" prop="description">
          <el-input
            type="textarea"
            :rows="4"
            v-model="categoryForm.description"
            placeholder="请输入分类描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number 
            v-model="categoryForm.sort" 
            :min="0" 
            :max="999" 
            placeholder="数字越小排序越靠前"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="categoryForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddDialog = false">取消</el-button>
        <el-button type="primary" @click="saveCategory" :loading="saving">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CategoryManage',
  data() {
    return {
      loading: false,
      saving: false,
      showAddDialog: false,
      isEdit: false,
      searchKeyword: '',
      selectedStatus: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      categoryList: [],
      categoryForm: {
        id: null,
        name: '',
        description: '',
        sort: 0,
        status: 1
      },
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        description: [
          { max: 200, message: '描述不能超过200个字符', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.loadCategories();
  },
  methods: {
    async loadCategories() {
      this.loading = true;
      try {
        const params = {
          pageSize: this.pageSize,
          pageNumber: this.currentPage,
          name: this.searchKeyword || undefined
        };
        
        // 只有当选择了具体状态时才传入status参数
        if (this.selectedStatus !== '') {
          params.status = this.selectedStatus;
        }
        
        const response = await this.$http({
          method: 'GET',
          url: this.$util.domain + '/adminapi/v1/courseType/list',
          params: params
        });
        
        if (response.data.error === 10000) {
          this.categoryList = response.data.data.resModels || [];
          this.total = response.data.data.count || 0;
        } else {
          this.$message.error(response.data.message || '获取分类列表失败');
        }
      } catch (error) {
        console.error('获取分类列表失败:', error);
        this.$message.error('获取分类列表失败，请检查网络连接');
      } finally {
        this.loading = false;
      }
    },
    searchCategories() {
      this.currentPage = 1;
      this.loadCategories();
    },
    resetSearch() {
      this.searchKeyword = '';
      this.selectedStatus = '';
      this.currentPage = 1;
      this.loadCategories();
    },
    addCategory() {
      // 跳转到新增页面
      this.$router.push('/yunying/course/category/edit/add');
    },
    editCategory(row) {
      // 跳转到编辑页面
      this.$router.push(`/yunying/course/category/edit/${row.id}`);
    },
    async deleteCategory(row) {
      if (row.courseCount > 0) {
        this.$message({
          message: `该分类下还有 ${row.courseCount} 个课程，无法删除！请先删除或转移相关课程。`,
          type: 'error',
          duration: 3000
        });
        return;
      }
      
      try {
        await this.$confirm('确认删除该分类吗？删除后不可恢复！', '删除确认', {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const response = await this.$http({
          method: 'GET',
          url: this.$util.domain + '/adminapi/v1/courseType/delete',
          params: { id: row.id }
        });
        
        if (response.data.error === 10000) {
          this.$message.success('删除成功');
          this.loadCategories();
        } else {
          this.$message.error(response.data.message || '删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除分类失败:', error);
          this.$message.error('删除失败，请检查网络连接');
        }
      }
    },
    async toggleStatus(row) {
      const action = row.status === 1 ? '下架' : '上架';
      const newStatus = row.status === 1 ? 0 : 1;
      let confirmText = `确认${action}该分类吗？`;
      
      if (row.status === 1 && row.courseCount > 0) {
        confirmText += `\n注意：下架后该分类下的 ${row.courseCount} 个课程将无法正常显示`;
      }
      
      try {
        await this.$confirm(confirmText, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const response = await this.$http({
          method: 'GET',
          url: this.$util.domain + '/adminapi/v1/courseType/change',
          params: { 
            id: row.id,
            status: newStatus
          }
        });
        
        if (response.data.error === 10000) {
          this.$message.success(`${action}成功`);
          this.loadCategories();
        } else {
          this.$message.error(response.data.message || `${action}失败`);
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('状态切换失败:', error);
          this.$message.error(`${action}失败，请检查网络连接`);
        }
      }
    },
    saveCategory() {
      this.$refs.categoryForm.validate((valid) => {
        if (valid) {
          this.saving = true;
          // 实际项目中调用保存API
          setTimeout(() => {
            this.$message.success(this.isEdit ? '编辑成功' : '添加成功');
            this.showAddDialog = false;
            this.saving = false;
            this.loadCategories();
          }, 1000);
        }
      });
    },
    resetForm() {
      this.isEdit = false;
      this.categoryForm = {
        id: null,
        name: '',
        description: '',
        sort: 0,
        status: 1
      };
      if (this.$refs.categoryForm) {
        this.$refs.categoryForm.resetFields();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.loadCategories();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadCategories();
    },
    // 格式化日期时间为年月日时分秒
    formatDateTime(dateTime) {
      if (!dateTime) return '';
      
      // 如果是时间戳（数字），转换为Date对象
      const date = typeof dateTime === 'number' ? new Date(dateTime) : new Date(dateTime);
      
      // 检查日期是否有效
      if (isNaN(date.getTime())) return '';
      
      // 使用项目中的dateFormat方法
      return this.$util.dateFormat(date, 'yyyy-MM-dd hh:mm:ss');
    }
  }
}
</script>

<style scoped>
.category-manage {
  padding: 20px;
}

.search-bar {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.add-section {
  margin-bottom: 20px;
}

.dialog-footer {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// categoryManage.vue?3d4769c3